<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Log de Ponto'" :showBtn="false" :btnName="''" :btnRoute="''" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>UserId</label>
                      <input v-model="dataSearch.userId" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Banco</label>
                      <input v-model="dataSearch.header" type="text" class="form-control" name="userId"
                             placeholder="UserID" required>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Data</label>
                      <datepicker v-model="dataSearch.date" :language="ptBR" :format="customFormatter"
                                  placeholder="Data" required/>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataPoint !== '' && !dataPoint.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultado na pesquisa.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataPoint.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de logs ({{ dataPoint.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> DATA REGISTRO</th>
                        <th> DATA ONLINE</th>
                        <th> DATA LOCAL</th>
                        <th> STATUS</th>
                        <th> JSON</th>
                        <th> MESSAGE</th>
                        <th> DEVICE</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataPoint">
                        <td>{{ c.date | formatFullDateS }}</td>
                        <td>{{ c.dateOnline }}</td>
                        <td>{{ c.dateLocal }}</td>
                        <td>{{ c.status }}</td>
                        <td>{{ c.json }}</td>
                        <td>{{ c.message }}</td>
                        <td>{{ c.device }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import swal from 'sweetalert';
import moment from 'moment'

import {
  GET_POINT_LOG
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";

export default {
  name: "log-point",
  components: {
    datepicker,
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      ptBR: ptBR,
      failRequest: false,
      loadingList: false,
      dataPoint: '',
      dataSearch: {
        header: 'AAAA',
        userId: '',
        date: ''
      },
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getList() {
      if (this.dataSearch.userId && this.dataSearch.date) {
        moment.locale('pt-br');

        this.loadingList = true;
        let url = GET_POINT_LOG;
        url += "?userId=" + this.dataSearch.userId;
        url += "&dt=" + moment(this.dataSearch.date).format("MM-DD-YYYY");

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.requestContext('GET', url, this.dataSearch.header).then((response) => {
          UTIL_SERVICE.console("RESULT GET_POINT_LOG:", response.data);

          this.dataPoint = response.data;
          this.loadingList = false;
          this.failRequest = false;
        }).catch((reason) => {
          this.loadingList = false;
          this.failRequest = true;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      } else {
        swal("Aviso", "Preencha os campos para pesquisar", "error");
      }
    }
  }
}
</script>

<style lang="scss">
.vdp-datepicker {
  display: inline-block;
  width: 90%;

  input {
    border: 1px solid #ccc;
    border-radius: 5px;
    height: 34px;
    width: 100%;
    padding: 0 10px;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/logPoint/logPoint.vue